import { classNames } from "primereact/utils";

const inputSwitch = {
  root: ({ props }) => ({
      className: classNames('inline-block relative', 'w-12 h-6', {
          'opacity-60 select-none pointer-events-none cursor-default': props.disabled
      })
  }),
  input: {
      className: classNames('absolute appearance-none top-0 left-0 size-full p-0 m-0 opacity-0 z-10 outline-none cursor-pointer')
  },
  slider: ({ props }) => ({
      className: classNames(
          'absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent',
          'transition-colors duration-200 rounded-2xl',
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
          "before:absolute before:content-'' before:top-1/2 before:w-4 before:h-4 before:left-1 before:-mt-2 before:rounded-full before:transition-duration-200",
          {
              'bg-grey-4 hover:bg-grey-6 before:bg-white': !props.checked,
              'bg-allstate-navy before:transform before:translate-x-[22px] before:bg-allstate-light-blue': !!props.checked
          }
      )
  })
}

export default inputSwitch;